import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('pt-br', 'receita/cadastro/vendedor', ptBr);
i18next.addResourceBundle('en', 'receita/cadastro/vendedor', en);

const VendedorConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/vendas-servicos/vendedores',
      component: React.lazy(() => import('./Vendedor')),
    },
  ],
};

export default VendedorConfig;
